import React from 'react'
import hoc from '@hoc'
import PropTypes from 'prop-types'
import { API, RISKMGT } from '@const'
import * as utils from '@utils'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Divider from '@material-ui/core/Divider'
import { TextField, Grid } from '@material-ui/core'

class EditRiskRuleHoneymoonDialog extends React.Component {
    constructor(props) {
        super(props)
        this.t = (key, options) => {
            return utils.t(key, 'EditRiskRuleHoneymoonDialog', options)
        }
    }

    state = { input: {}, dialogOpen: false, isLoading: false }

    componentDidMount() {
        this.props.onRef(this)
    }

    componentWillUnmount() {
        this.props.onRef(undefined)
    }

    reset(pfSubPfId, riskRuleList) {
        const honeymoon1RiskRule = riskRuleList[utils.ComposeRiskRuleKey(RISKMGT.RISK_LABEL_HONEYMOON_1, pfSubPfId)]
        const honeymoon2RiskRule = riskRuleList[utils.ComposeRiskRuleKey(RISKMGT.RISK_LABEL_HONEYMOON_2, pfSubPfId)]

        this.setState({
            input: {
                honeymoon1_round_below: honeymoon1RiskRule.round_boundary[1],
                honeymoon2_round_below: honeymoon2RiskRule.round_boundary[1],
            },
            riskRuleList: riskRuleList,
            pfSubPfId: pfSubPfId,
            isLoading: false,
        })
    }

    OpenDialog(pfSubPfId, riskRuleList) {
        this.reset(pfSubPfId, riskRuleList)
        this.setState({ dialogOpen: true })
    }

    closeDialog() {
        this.setState({ dialogOpen: false })
    }

    confirm() {
        if (parseInt(this.state.input.honeymoon1_round_below) >= parseInt(this.state.input.honeymoon2_round_below)) {
            utils.addToast(this.t('invalidParams'), 'error')
            this.setState({ isLoading: false })
            return
        }

        const promiseList = []

        const honeymoon1RiskRule = this.state.riskRuleList[utils.ComposeRiskRuleKey(RISKMGT.RISK_LABEL_HONEYMOON_1, this.state.pfSubPfId)]
        const updateHoneymoon1RulePromise = new Promise((resolve, reject) => {
            utils.apiRequest(
                'patch',
                API.RISKMGT_RISK_RULE,
                {
                    id: honeymoon1RiskRule.id,
                    round_boundary: [0, parseInt(this.state.input.honeymoon1_round_below)],
                },
                (_data) => {
                    resolve()
                },
                () => {
                    reject()
                },
                true
            )
        })
        promiseList.push(updateHoneymoon1RulePromise)

        const honeymoon2RiskRule = this.state.riskRuleList[utils.ComposeRiskRuleKey(RISKMGT.RISK_LABEL_HONEYMOON_2, this.state.pfSubPfId)]
        const updateHoneymoon2RulePromise = new Promise((resolve, reject) => {
            utils.apiRequest(
                'patch',
                API.RISKMGT_RISK_RULE,
                {
                    id: honeymoon2RiskRule.id,
                    round_boundary: [parseInt(this.state.input.honeymoon1_round_below) + 1, parseInt(this.state.input.honeymoon2_round_below)],
                },
                (_data) => {
                    resolve()
                },
                () => {
                    reject()
                },
                true
            )
        })
        promiseList.push(updateHoneymoon2RulePromise)

        Promise.all(promiseList)
            .then(() => {
                utils.addToast(this.t('success'), 'success')
                this.props.confirmCallback()
                this.closeDialog()
            })
            .catch(() => {
                // this.setState({ confirmDisabled: false });
            })
    }

    render() {
        return (
            <Dialog open={this.state.dialogOpen} onClose={() => this.setState({ dialogOpen: false })}>
                <DialogTitle>
                    {this.t('Title', {
                        game_name: this.t('GameName.' + this.state.input.game_code),
                    })}
                </DialogTitle>
                <DialogContent>
                    <Grid container spacing={2}>
                        <Grid item xs={8}>
                            <TextField
                                label={this.t('honeymoon1RoundBelow')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={this.state.input.honeymoon1_round_below}
                                onChange={(event) => {
                                    let value = parseInt(event.target.value)
                                    if (value < 0 || isNaN(value)) {
                                        value = 0
                                    }

                                    this.setState({
                                        input: {
                                            ...this.state.input,
                                            honeymoon1_round_below: value,
                                        },
                                    })
                                }}
                                margin="dense"
                                fullWidth
                            />
                        </Grid>
                        <Grid item xs={8}>
                            <TextField
                                label={this.t('honeymoon2RoundBelow')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                value={this.state.input.honeymoon2_round_below}
                                onChange={(event) => {
                                    let value = parseInt(event.target.value)
                                    if (value < 0 || isNaN(value)) {
                                        value = 0
                                    }

                                    this.setState({
                                        input: {
                                            ...this.state.input,
                                            honeymoon2_round_below: value,
                                        },
                                    })
                                }}
                                margin="dense"
                                fullWidth
                            />
                        </Grid>
                    </Grid>
                </DialogContent>
                <Divider />
                <DialogActions>
                    <Button
                        variant="contained"
                        onClick={() => {
                            this.setState({ isLoading: true })
                            this.confirm()
                        }}
                        color="primary"
                        disabled={this.state.isLoading}>
                        {this.t('confirm')}
                    </Button>
                    <Button variant="contained" onClick={() => this.closeDialog()} color="secondary">
                        {this.t('cancel')}
                    </Button>
                </DialogActions>
            </Dialog>
        )
    }
}

const styles = (_theme) => {
    return {}
}

EditRiskRuleHoneymoonDialog.propTypes = {
    classes: PropTypes.object.isRequired,
    onRef: PropTypes.func,
    confirmCallback: PropTypes.func,
}

export default hoc(styles)(EditRiskRuleHoneymoonDialog)
